import React from 'react';

import PropTypes from 'prop-types';

import { Avatar, Box, Grid, Typography } from '@mui/material';

import { Quote } from 'lucide-react';

import { COLORS } from '../../../Constant/COLORS';

const ItemAvatarProfessionals = ({ text, name, job, avatar, ...rest }) => (
  <Grid item {...rest}>
    <Box
      sx={{
        height: '100%',
        p: { xs: 3, md: 4 },
        borderRadius: 4,
        bgcolor: COLORS.surface,
        border: `1px solid ${COLORS.hairline}`,
        boxShadow: '0 1px 2px rgba(14,27,31,0.04), 0 6px 20px rgba(14,27,31,0.06)',
        transition: 'transform .3s cubic-bezier(0.22,1,0.36,1), box-shadow .3s ease',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: '0 18px 40px rgba(14,27,31,0.12)',
        },
      }}
    >
      <Quote size={30} color={COLORS.teal} fill={COLORS.tealSoft} strokeWidth={1.4} />
      <Typography variant='body2' sx={{ color: COLORS.inkSoft, mt: 1.5, lineHeight: 1.7 }}>
        {text}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 3 }}>
        <Avatar src={avatar} sx={{ width: 52, height: 52 }} />
        <Box>
          <Typography variant='subtitle2' fontWeight={700} color={COLORS.ink}>
            {name}
          </Typography>
          <Typography variant='caption' sx={{ color: COLORS.teal, fontWeight: 600 }}>
            {job}
          </Typography>
        </Box>
      </Box>
    </Box>
  </Grid>
);

ItemAvatarProfessionals.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  job: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  rest: PropTypes.object,
};

export default ItemAvatarProfessionals;
